import React from 'react'
import { AddOnInfo } from 'components/enrollForm/enrollFormTypes'
import {
    BulkEnrollmentSelectedAddOn,
    formatBulkEnrollmentAmount,
    formatBulkEnrollmentDiscount,
    getBulkEnrollmentAddOnQuantity,
    getBulkEnrollmentDiscountAmount,
    getExistingProductQuantity
} from 'helpers/bulkEnrollmentHelpers'
import { BulkEnrollmentQuantityStepper } from './BulkEnrollmentQuantityStepper'
import { ClientType } from 'storeTypes'

type BulkEnrollmentAddOnGridProps = {
    addOns: AddOnInfo[]
    selectedAddOns: BulkEnrollmentSelectedAddOn[]
    client?: ClientType | null
    readOnly?: boolean
    onQuantityChange: (packageId: string, quantity: number) => void
}

export const BulkEnrollmentAddOnGrid = ({
    addOns,
    selectedAddOns,
    client,
    readOnly = false,
    onQuantityChange
}: BulkEnrollmentAddOnGridProps) => {
    if (!addOns.length) {
        return null
    }

    return (
        <div className="bulk-enrollment-addons">
            {addOns.map((addOn) => {
                const quantity = getBulkEnrollmentAddOnQuantity(
                    selectedAddOns,
                    addOn.package_id
                )
                const isSelected = quantity > 0
                const addOnDiscount = getBulkEnrollmentDiscountAmount(
                    addOn.discount,
                    quantity,
                    getExistingProductQuantity(
                        client,
                        addOn.product_id,
                        addOn.package_id
                    )
                )
                const addOnNet =
                    (Number(addOn.price) || 0) * Math.max(quantity, 1) -
                    addOnDiscount

                return (
                    <div
                        key={addOn.package_id}
                        className={`bulk-enrollment-package-row ${
                            isSelected
                                ? 'bulk-enrollment-package-row--selected'
                                : ''
                        }`}
                        data-testid={`bulk-enrollment-addon-${addOn.package_id}`}
                    >
                        <div className="bulk-enrollment-package-row__product">
                            {addOn.image_url ? (
                                <img
                                    src={addOn.image_url}
                                    alt={addOn.product_name}
                                    className="bulk-enrollment-package-row__image"
                                />
                            ) : (
                                <div
                                    className="bulk-enrollment-package-row__image bulk-enrollment-package-row__image--empty"
                                    aria-hidden="true"
                                />
                            )}
                            <div className="bulk-enrollment-package-row__meta">
                                <p className="bulk-enrollment-package-row__name">
                                    {addOn.product_name}
                                </p>
                                <p className="bulk-enrollment-package-row__size">
                                    {addOn.size_display || addOn.size}
                                </p>
                                <p className="bulk-enrollment-package-row__price">
                                    {formatBulkEnrollmentAmount(
                                        isSelected
                                            ? addOnNet
                                            : addOn.price,
                                        addOn.hide_price
                                    )}
                                </p>
                                {isSelected && addOnDiscount > 0 && (
                                    <p className="bulk-enrollment-package-row__discount">
                                        {formatBulkEnrollmentDiscount(
                                            addOnDiscount,
                                            addOn.hide_price
                                        )}
                                    </p>
                                )}
                            </div>
                        </div>
                        <BulkEnrollmentQuantityStepper
                            quantity={quantity}
                            min={0}
                            label={addOn.product_name}
                            compactAdd
                            disabled={readOnly}
                            onChange={(nextQuantity) =>
                                onQuantityChange(
                                    addOn.package_id,
                                    nextQuantity
                                )
                            }
                        />
                    </div>
                )
            })}
        </div>
    )
}
